import { createSlice, EntityState } from '@reduxjs/toolkit';
import { Driver } from '../models/driver.model';
import { driverAdapter } from '../entities/driver.entity';
import { AppDispatch, RootState } from '../store';

type DriverEntityState = {
  loadingDriver: boolean;
  loadedDriver: boolean;
};

const driverSlice = createSlice({
  name: 'driverV2',
  initialState: driverAdapter.getInitialState<DriverEntityState>({
    loadingDriver: false,
    loadedDriver: false,
  }),
  reducers: {
    setDrivers: (state, action: { payload: Driver[] }) => {
      driverAdapter.setMany(state, action.payload);
    },
    setDriver: (state, action: { payload: Driver }) => {
      driverAdapter.setOne(state, action.payload);
    },
    setLoadingDriver: (state, action: { payload: boolean }) => {
      state.loadingDriver = action.payload;
    },
    setLoadedDriver: (state, action: { payload: boolean }) => {
      state.loadedDriver = action.payload;
    },
    upsertDrivers: (state, action: { payload: Driver[] }) => {
      driverAdapter.upsertMany(state, action.payload);
    },
    upsertDriver: (state, action: { payload: Driver }) => {
      driverAdapter.upsertOne(state, action.payload);
    },
  },
});

const {
  setDrivers,
  setDriver,
  setLoadingDriver,
  setLoadedDriver,
  upsertDrivers,
  upsertDriver,
} = driverSlice.actions;

/*
 * Selectors
 * All necessary selectors for filtering and sorting trip legs for various
 * pages, including trip management and monitoring.
 */

const driverSelectors = driverAdapter.getSelectors<RootState>(
  (state) => state.driverV2,
);

const selectDriverById = (state: RootState, driverID: number) =>
  driverSelectors.selectById(state, driverID);

export { driverSlice, driverSelectors, selectDriverById };
